/**
 * UserSig 过期测试开关（代码常量，手动切换）
 *
 * 用法：想本地验证 UserSig 过期自恢复流程时，把下方 `FORCE_EXPIRE_USERSIG`
 * 临时改成 `true`，然后登录 / F5——后端会返回 1 秒有效期的独立预览签，
 * SDK 登录后会在 1 秒内抛 70001 / kickedOut，走完整的
 * "销毁 + force_refresh + 重建"恢复流程。验证完把它改回 `false`。
 *
 * 强约束
 * - 提交代码前必须保证为 `false`
 * - 过期自恢复分支 (`recoverFromUserSigExpired`) 内部不走此开关
 *   （否则会陷入"1 秒过期 → 重连 → 1 秒过期"死循环）
 */

// ⚠️ 手动切换：仅本地调试用，提交前必须改回 false
const FORCE_EXPIRE_USERSIG = false;

/** 是否启用"1 秒 UserSig"测试模式 */
export function shouldUseExpireUserSigForTest(): boolean {
  return FORCE_EXPIRE_USERSIG;
}
